import React from "react";
import { Spin, Alert } from "antd";
import { useTranslation } from "react-i18next";

interface TestRunningSectionProps {
  onStopTest: () => void;
  loading: boolean;
  elapsedTime?: number | null;
}

export const TestRunningSection: React.FC<TestRunningSectionProps> = ({
  onStopTest,
  loading,
  elapsedTime,
}) => {
  const { t } = useTranslation("settings");

  return (
    <div className="test-running-section">
      <Spin size="large" />
      <p>{t("test_running")}</p>
      <p className="test-status-text">{t("waiting_for_results")}</p>
      {elapsedTime !== null && elapsedTime !== undefined && (
        <p className="test-status-text" style={{ fontSize: "12px", marginTop: "10px" }}>
          {elapsedTime}s
        </p>
      )}
      <button
        className="stop-test-btn"
        onClick={onStopTest}
        disabled={loading}
        style={{ marginTop: "20px" }}
      >
        {loading ? <Spin size="small" /> : t("stop_test")}
      </button>
    </div>
  );
};

